import React from 'react';
import { ChildrenProp } from '../common-types';

/**
 * Properties for a {@link DocumentGroup} component.
 */
export interface DocumentGroupProps extends Required<ChildrenProp> {
  /**
   * Optional title of the group.
   */
  title?: string;
}

/**
 * Component used to link multiple {@link Document}s together visually.
 *
 * @param props {@link DocumentGroupProps} object
 * @return the rendered {@link JSX.Element}
 * @constructor
 */
export function DocumentGroup(props: DocumentGroupProps): JSX.Element {
  return React.Children.count(props.children) > 1 ? (
    // add group container if more than 1 child
    <div className={'ehs-document-group'}>
      {props.title ? (
        <h3 className="document-group-title">{props.title}</h3>
      ) : (
        <></>
      )}
      {props.children}
    </div>
  ) : (
    // wrapped with empty element, to avoid any kind of casting. This is either 1 or 0 Document components
    <>{props.children}</>
  );
}
